export const blockIconsEditorBarChart = (
	<span className='material-symbols-outlined'>bar_chart</span>
);
